<div class="faq-image-panel-item" (click)="handleToggleItem(item)">
  <div class="collapsible" id="{{ item.anchor?.value }}">
    <div
      class="collapsible__item"
      [class.collapsible__item--opened]="
        item.state === accordionItemState.opened
      "
    >
      <div class="collapsible__item-trigger">
        {{ item.question?.value }}
        <i class="icon icon-trigger"></i>
      </div>
      <div
        class="collapsible__item-content"
        [@animation]="item.state"
        [innerHTML]="item.answer.value | safe"
        #itemDisc
      ></div>
    </div>
  </div>
</div>
